import { render, staticRenderFns } from "./NotificationConfig.vue?vue&type=template&id=591d131c&scoped=true"
import script from "./NotificationConfig.vue?vue&type=script&lang=js"
export * from "./NotificationConfig.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfig.vue?vue&type=style&index=0&id=591d131c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d131c",
  null
  
)

export default component.exports